import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 120px;
`;

export const SearchModal = styled.div`
  background: #fff;
  border-radius: 6px;
  width: 100%;
  max-width: 600px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.2);
  overflow: hidden;
`;

export const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #EBEBEB;
  gap: 12px;
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  font-family: Poppins, sans-serif;
  font-weight: 400;
  color: ${theme.colors.base_800};
  background: transparent;
  &::placeholder {
    color: ${theme.colors.dkgrey};
  }
`;

export const SearchShortcut = styled.span`
  font-size: 11px;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  color: ${theme.colors.dkgrey};
  background: ${theme.colors.base_100};
  border: 1px solid ${theme.colors.base_300};
  border-radius: 4px;
  padding: 2px 6px;
  white-space: nowrap;
`;

export const ResultsContainer = styled.div`
  overflow-y: auto;
  flex: 1;
`;

export const ResultsSection = styled.div`
  &:not(:first-child) {
    border-top: 1px solid #EBEBEB;
    margin-top: 4px;
  }
`;

export const SectionHeader = styled.div`
  font-size: 11px;
  font-weight: 600;
  font-family: Rubik, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${theme.colors.dkgrey};
  padding: 12px 20px 6px;
  background: ${theme.colors.base_100};
`;

export const ResultItem = styled.div<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  cursor: pointer;
  background: ${(props) => (props.$active ? theme.colors.base_100 : "transparent")};
  &:hover {
    background: ${theme.colors.base_100};
  }
`;

export const ResultLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-family: Poppins, sans-serif;
  color: ${theme.colors.base_800};
  line-height: 20px;
`;

export const ResultSublabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  font-family: Poppins, sans-serif;
  color: ${theme.colors.dkgrey};
  line-height: 18px;
`;

export const EmptyState = styled.div`
  padding: 40px 20px;
  text-align: center;
  font-size: 14px;
  font-family: Poppins, sans-serif;
  color: ${theme.colors.dkgrey};
`;

export const LoadingWrapper = styled.div`
  padding: 40px 20px;
  text-align: center;
  font-size: 14px;
  font-family: Poppins, sans-serif;
  color: ${theme.colors.dkgrey};
`;

export const HighlightMark = styled.mark`
  background: rgba(202, 161, 28, 0.2);
  color: inherit;
  border-radius: 2px;
  padding: 0;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 20px;
  border-top: 1px solid #EBEBEB;
  font-size: 11px;
  font-family: Poppins, sans-serif;
  color: ${theme.colors.dkgrey};
`;

export const FooterKeys = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FooterKey = styled.span`
  background: ${theme.colors.base_100};
  border: 1px solid ${theme.colors.base_300};
  border-radius: 3px;
  padding: 1px 5px;
  font-size: 10px;
  font-weight: 500;
`;
